export default __webpack_public_path__ + "static/banner-no-text-979eb975069cec68070467dba208e2db.jpg";